module.exports = __webpack_public_path__ + "img/insurita-section-one-right.e43a09c9.svg";